import React from 'react';
import classNames from 'classnames';
import { ButtonProps } from './props.type';
import { Size } from '../../enums/size';
import { Icon } from '../icon';
import * as styles from './button.module.sass'
import { Color } from '../../enums/color';
import { useFormikContext } from 'formik';


export const Button = (props: ButtonProps) => {
  const {
    text = '',
    className = '',
    size = Size.MEDIUM,
    iconAvailable = false,
    onClick,
    disabled = false,
    href,
    isTextWithWrapper,
    type = 'button',
    icon,
    color = Color.DEFAULT
  } = props;


  const content = (
    <>
      {iconAvailable && (
        <Icon
          icon={icon}
          size={size}
          className={isTextWithWrapper ? styles.is_icon_show : 'marginRight'}
        />
      )}
      {text}
    </>
  );

  const classForTag = classNames(
    styles[size],
    styles.button,
    styles[color],
    className,
    { [styles.disabled]: disabled }
  );

  let checkLinkPresrnce = (
    <button type={type} className={classNames( classForTag)} disabled={disabled} onClick={onClick}>
      {content}
    </button>
  );

  if (href) {
    checkLinkPresrnce = (
      <a href={href} className={classForTag}>
        {content}
      </a>
    );
  }

  return checkLinkPresrnce;
};
